import palette from '@lib/core/src/theme/palette';
import { IconButton, Stack, styled, TextField } from '@mui/material';

export const InputAndAvatarsContainer = styled(Stack)({
  position: 'relative'
});

export const SmallAvatars = styled(Stack)<{ width: string }>(({ width }) => ({
  position: 'absolute',
  zIndex: 1,
  top: '50%',
  left: '5px',
  transform: 'translate(0, -50%)',
  width: width,
  height: '30px',
  backgroundColor: palette.white,
  cursor: 'pointer'
}));

export const TextInputSelect = styled(TextField, {
  shouldForwardProp: prop => prop !== 'iserror' && prop !== 'isvalid'
})<{ marginleft: string; isvalid: boolean }>(({ marginleft, isvalid }) => ({
  border: 'none',
  resize: 'vertical',
  '&::after': {
    content: '"!"',
    display: isvalid ? 'none' : 'block',
    color: 'red',
    position: 'absolute',
    right: '25px',
    top: '50%',
    transform: 'translateY(-50%)'
  },
  '& .MuiOutlinedInput-root': {
    backgroundColor: palette.white,
    backdropFilter: 'blur(12.5px)',
    height: '100%',
    width: 'unset',
    borderRadius: '10px',
    alignItems: 'baseline',
    border: `1px solid ${palette.stroke.idle}`,
    '& .MuiOutlinedInput-input': {
      height: '100%',
      padding: 0,
      fontSize: '13px',
      fontWeight: '500',
      lineHeight: '16px',
      color: isvalid ? palette.grey[600] : palette.black,
      marginLeft: marginleft
    },
    '&:hover': {
      '& .MuiOutlinedInput-notchedOutline': { borderColor: palette.border.grey }
    },
    '& .MuiOutlinedInput-notchedOutline': { borderColor: palette.border.grey, border: 'none' }
  }
}));

export const ExpandUpDownContainer = styled(IconButton)({
  position: 'absolute',
  right: '2px',
  top: '50%',
  transform: 'translateY(-50%)',
  cursor: 'pointer'
});

export const LoadingContainer = styled(Stack)({
  position: 'absolute',
  right: '26px',
  top: '50%',
  transform: 'translateY(-50%)'
});
